export class Store {
  #state;
  #listeners = new Set();

  constructor(initial) {
    this.#state = { ...initial };
  }

  get state() {
    return this.#state;
  }

  set(patch) {
    this.#state = { ...this.#state, ...patch };
    this.#listeners.forEach((listener) => listener(this.#state));
  }

  subscribe(listener) {
    this.#listeners.add(listener);
    return () => this.#listeners.delete(listener);
  }
}
